var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1196 15H21C18.1716 15 16.7574 15 15.8787 15.8787C15 16.7574 15 18.1716 15 21V29C15 31.8284 15 33.2426 15.8787 34.1213C16.7574 35 18.1716 35 21 35H29C31.8284 35 33.2426 35 34.1213 34.1213C35 33.2426 35 31.8284 35 29V18.881L30.1196 15ZM18.5297 21.3632C18.5297 20.6867 18.5297 20.3484 18.6107 20.0725C18.8025 19.4194 19.3132 18.9087 19.9662 18.717C20.2421 18.6359 20.5804 18.6359 21.257 18.6359H26.9789C27.6554 18.6359 27.9937 18.6359 28.2696 18.717C28.9227 18.9087 29.4334 19.4194 29.6251 20.0725C29.7062 20.3484 29.7062 20.6867 29.7062 21.3632C29.7062 22.0398 29.7062 22.378 29.6251 22.6539C29.4334 23.307 28.9227 23.8177 28.2696 24.0095C27.9937 24.0905 27.6554 24.0905 26.9789 24.0905H21.257C20.5804 24.0905 20.2421 24.0905 19.9662 24.0095C19.3132 23.8177 18.8025 23.307 18.6107 22.6539C18.5297 22.378 18.5297 22.0398 18.5297 21.3632ZM25.2943 31.5391C26.5938 31.5391 27.6473 30.4537 27.6473 29.1149C27.6473 27.776 26.5938 26.6906 25.2943 26.6906C23.9949 26.6906 22.9414 27.776 22.9414 29.1149C22.9414 30.4537 23.9949 31.5391 25.2943 31.5391Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareicon);
export default __webpack_public_path__ + "static/media/shareicon.9045af87d4664bfff25add8b0ea44826.svg";
export { ForwardRef as ReactComponent };